<section class="bg-white dark:bg-gray-900">
  <!-- Hero -->
  <div class="border-b border-gray-100 bg-gray-50/60 px-4 py-10 dark:border-gray-800 dark:bg-white/[0.02] sm:px-6 sm:py-14 lg:px-10">
    <div class="mx-auto max-w-screen-xl">
      <span
        class="inline-flex items-center rounded-full bg-brand-50 px-3 py-1 text-xs font-semibold tracking-wide text-brand-600 uppercase dark:bg-brand-500/10 dark:text-brand-400">
        {{ kicker }}
      </span>
      <h1 class="mt-4 text-title-sm font-semibold text-gray-800 dark:text-white/90 sm:text-title-md">
        {{ title }}
      </h1>
      <p *ngIf="description" class="mt-3 max-w-2xl text-sm text-gray-500 dark:text-gray-400 sm:text-base">
        {{ description }}
      </p>
      <div *ngIf="metaLines.length" class="mt-5 flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-400 dark:text-gray-500">
        <span *ngFor="let m of metaLines">{{ m }}</span>
      </div>
    </div>
  </div>

  <div class="mx-auto max-w-screen-xl px-4 py-8 sm:px-6 lg:px-10 lg:py-12">
    <!-- Mobile / tablet TOC -->
    <details *ngIf="sections.length"
      class="mb-6 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.02] lg:hidden">
      <summary class="cursor-pointer text-sm font-semibold text-gray-800 select-none dark:text-white/90">
        On this page
      </summary>
      <nav class="mt-3 flex flex-col gap-0.5">
        <a *ngFor="let s of sections" [href]="'#' + s.id" (click)="jumpToSection($event, s.id)"
          class="rounded-lg px-2 py-1.5 text-sm text-gray-600 hover:bg-gray-50 hover:text-brand-500 dark:text-gray-400 dark:hover:bg-white/5">
          {{ s.label }}
        </a>
      </nav>
    </details>

    <div class="lg:grid lg:grid-cols-[240px_1fr] lg:gap-10 xl:grid-cols-[280px_1fr]">
      <!-- Desktop TOC -->
      <aside *ngIf="sections.length" class="hidden lg:block">
        <nav class="custom-scrollbar sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto pr-2">
          <p class="mb-3 text-xs font-semibold tracking-wide text-gray-400 uppercase dark:text-gray-500">
            On this page
          </p>
          <ul class="space-y-0.5 border-l border-gray-200 dark:border-gray-800">
            <li *ngFor="let s of sections">
              <a [href]="'#' + s.id" (click)="jumpToSection($event, s.id)"
                class="-ml-px block border-l-2 px-3 py-1.5 text-sm transition-colors"
                [ngClass]="activeId() === s.id
                  ? 'border-brand-500 font-semibold text-brand-500'
                  : 'border-transparent text-gray-500 hover:text-gray-800 dark:text-gray-400 dark:hover:text-white/90'">
                {{ s.label }}
              </a>
            </li>
          </ul>
        </nav>
      </aside>

      <!-- Content -->
      <div class="legal-content min-w-0">
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <!-- Back to top -->
  <button *ngIf="showBackToTop()" (click)="scrollToTop()"
    class="fixed right-5 bottom-5 z-30 flex h-11 w-11 items-center justify-center rounded-full bg-brand-500 text-white shadow-lg transition-colors hover:bg-brand-600 sm:right-8 sm:bottom-8"
    aria-label="Back to top">
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
      stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 19V5" />
      <path d="M5 12l7-7 7 7" />
    </svg>
  </button>
</section>
